import { render, staticRenderFns } from "./UploadSelectorView.vue?vue&type=template&id=3562a7a8&scoped=true&"
import script from "./UploadSelectorView.vue?vue&type=script&lang=js&"
export * from "./UploadSelectorView.vue?vue&type=script&lang=js&"
import style0 from "./UploadSelectorView.vue?vue&type=style&index=0&id=3562a7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562a7a8",
  null
  
)

export default component.exports